var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiNhandinh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_375_9647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4108 1.55139V3.87842",
    stroke: "#B8ADAF",
    strokeWidth: 1.29661,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20544 1.55139V3.87842",
    stroke: "#B8ADAF",
    strokeWidth: 1.29661,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32703 6.17247C2.32703 4.26288 3.87506 2.71484 5.78465 2.71484H12.8316C14.7411 2.71484 16.2892 4.26288 16.2892 6.17247V13.6072C16.2892 15.5168 14.7411 17.0648 12.8315 17.0648H5.78465C3.87506 17.0648 2.32703 15.5168 2.32703 13.6072V6.17247Z",
    stroke: "#B8ADAF",
    strokeWidth: 1.29661
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32703 6.98108H16.2892",
    stroke: "#B8ADAF",
    strokeWidth: 1.29661,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5492 14.2178C9.49174 14.1882 9.42352 14.1882 9.36605 14.2178L7.69732 15.0772C7.54711 15.1546 7.37459 15.0223 7.41025 14.8572L7.77278 13.1782C7.78833 13.1062 7.76301 13.0314 7.70688 12.9837L6.35356 11.8323C6.21991 11.7186 6.28702 11.5002 6.46146 11.4812L8.32355 11.278C8.39105 11.2706 8.4502 11.2295 8.48064 11.1688L9.27884 9.5768C9.35262 9.42965 9.56264 9.42965 9.63641 9.5768L10.4346 11.1688C10.4651 11.2295 10.5242 11.2706 10.5917 11.278L12.4538 11.4812C12.6282 11.5002 12.6953 11.7186 12.5617 11.8323L11.2084 12.9837C11.1522 13.0314 11.1269 13.1062 11.1425 13.1782L11.505 14.8572C11.5407 15.0223 11.3681 15.1546 11.2179 15.0772L9.5492 14.2178Z",
    stroke: "#B8ADAF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_375_9647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6162,
    height: 18.6162,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiNhandinh);
export default __webpack_public_path__ + "static/media/mi-nhandinh.8976865206c557ba46fb0f3e4a23d0b3.svg";
export { ForwardRef as ReactComponent };